"use client";

// src/model-context/makeAssistantToolUI.tsx
import {
  useAssistantToolUI
} from "./useAssistantToolUI.js";
var makeAssistantToolUI = (tool) => {
  const ToolUI = () => {
    useAssistantToolUI(tool);
    return null;
  };
  ToolUI.unstable_tool = tool;
  return ToolUI;
};
export {
  makeAssistantToolUI
};
//# sourceMappingURL=makeAssistantToolUI.js.map